export type CatKey = "明星" | "网红" | "综艺" | "剧组";

export interface SceneItem {
  id: string;
  cat: CatKey;
  tag: string;
  title: string;
  excerpt: string;
  read: string;
  img: string;
  time: string;
}

export const CATS: Array<{ key: CatKey; label: string; hint: string }> = [
  { key: "明星", label: "明星名场面", hint: "高光瞬间与人物关系" },
  { key: "网红", label: "网红现场", hint: "圈层爆点与连麦名场面" },
  { key: "综艺", label: "综艺高能", hint: "热播综艺名场面复盘" },
  { key: "剧组", label: "剧组趣闻", hint: "台前幕后剧组生态" },
];

export const SCENES: SceneItem[] = [
  {
    id: "s01", cat: "明星", tag: "红毯名场面", read: "4分钟",
    title: "颁奖礼后台的「黄金三分钟」，一句话化解全场尴尬",
    excerpt: "当镜头扫过、话筒突然失灵，一位老牌演员用一句即兴发言稳住全场。名场面背后的临场功力，比热搜更值得复盘。",
    time: "2026.09.06",
    img: "https://readdy.ai/api/search-image?query=cinematic%20backstage%20of%20an%20award%20ceremony%2C%20warm%20coral%20and%20amber%20stage%20glow%2C%20silhouettes%20of%20people%20near%20a%20glowing%20spotlight%20curtain%2C%20editorial%20magazine%20style%2C%20soft%20shadows%2C%20no%20readable%20faces&width=800&height=600&seq=scene-s01&orientation=landscape",
  },
  {
    id: "s02", cat: "网红", tag: "连麦爆点", read: "3分钟",
    title: "一场连麦意外跑题，弹幕区的「神接梗」成了真顶流",
    excerpt: "原计划聊干货的直播间突然跑偏，主播顺势把话筒交给观众。谁说名场面只在台前？实时互动本身就是高能现场。",
    time: "2026.09.05",
    img: "https://readdy.ai/api/search-image?query=vibrant%20live%20streaming%20studio%20scene%20with%20ring%20light%20and%20monitor%20glow%2C%20mint%20green%20and%20cream%20tones%2C%20modern%20clean%20desk%2C%20editorial%20photography%2C%20no%20recognizable%20person%20face&width=800&height=600&seq=scene-s02&orientation=landscape",
  },
  {
    id: "s03", cat: "综艺", tag: "真人秀", read: "5分钟",
    title: "荒岛求生那期「无声剪辑」，把一整季的情绪都点着了",
    excerpt: "没有一句旁白、全靠镜头语言推进的三分钟，让观察室的嘉宾集体沉默。好的综艺名场面，往往不需要台词。",
    time: "2026.09.04",
    img: "https://readdy.ai/api/search-image?query=cinematic%20survival%20reality%20show%20island%20outdoor%20at%20dusk%2C%20warm%20orange%20sunset%20over%20seashore%2C%20campfire%20embers%2C%20film%20grain%2C%20editorial%20documentary%20style&width=800&height=600&seq=scene-s03&orientation=landscape",
  },
  {
    id: "s04", cat: "剧组", tag: "幕后花絮", read: "4分钟",
    title: "一条拍了三十遍的雨中戏，最后用的是第一版",
    excerpt: "导演纠结到凌晨的取舍，反而印证了最初直觉。剧组趣闻背后，是主创对「恰到好处」的反复拉锯与默契。",
    time: "2026.09.03",
    img: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20set%20on%20a%20rainy%20night%2C%20camera%20equipment%20and%20lights%20on%20set%2C%20wet%20reflective%20pavement%2C%20teal%20and%20amber%20cinematic%20grade%2C%20editorial%20photo&width=800&height=600&seq=scene-s04&orientation=landscape",
  },
  {
    id: "s05", cat: "明星", tag: "颁奖后台", read: "3分钟",
    title: "获奖感言只说了一句的演员，为什么全网都在夸",
    excerpt: "在人人争分夺秒的年代，一句克制而真诚的致谢反而成了最具传播力的名场面。分寸感，是圈子里稀缺的品质。",
    time: "2026.09.02",
    img: "https://readdy.ai/api/search-image?query=minimal%20elegant%20red%20carpet%20backdrop%20with%20soft%20bokeh%20lights%20and%20marble%20texture%2C%20coral%20and%20cream%20palette%2C%20premium%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=scene-s05&orientation=landscape",
  },
  {
    id: "s06", cat: "网红", tag: "破圈时刻", read: "4分钟",
    title: "从点赞几百到热搜第一，一条二创视频如何改变圈层",
    excerpt: "当小众圈子的梗被大众接受，跨圈传播的路径值得被复盘。网红现场最精彩的，往往是「从圈内到圈外」的跳变。",
    time: "2026.09.01",
    img: "https://readdy.ai/api/search-image?query=dynamic%20abstract%20motion%20of%20digital%20pixels%20and%20light%20streaks%20forming%20a%20wave%2C%20warm%20coral%20mint%20and%20cream%20colors%2C%20energetic%20editorial%20illustration%20style&width=800&height=600&seq=scene-s06&orientation=landscape",
  },
  {
    id: "s07", cat: "综艺", tag: "观察室", read: "3分钟",
    title: "观察室的一个表情，被观众解读成「全场最佳评论」",
    excerpt: "真正的名场面不一定在舞台中央。观察室里那些真实而细微的反应，常常比台本更能戳中观众的共情点。",
    time: "2026.08.30",
    img: "https://readdy.ai/api/search-image?query=cozy%20tv%20observation%20studio%20lounge%20with%20sofa%20and%20warm%20lamps%2C%20soft%20afternoon%20light%2C%20cream%20and%20amber%20tones%2C%20editorial%20interior%20photography%2C%20no%20people&width=800&height=600&seq=scene-s07&orientation=landscape",
  },
  {
    id: "s08", cat: "剧组", tag: "群演日常", read: "5分钟",
    title: "片场盒饭时间，那些镜头外的真实剧组生态",
    excerpt: "开机前的围读、收工后的复盘、群演与主演的短暂交错，构成一部戏最柔软的底色。剧组趣闻从来不止于笑料。",
    time: "2026.08.29",
    img: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20crew%20break%20area%20with%20folding%20tables%20and%20food%20boxes%2C%20natural%20warm%20light%20on%20set%20equipment%2C%20documentary%20editorial%20photo%2C%20no%20recognizable%20faces&width=800&height=600&seq=scene-s08&orientation=landscape",
  },
  {
    id: "s09", cat: "明星", tag: "音乐现场", read: "4分钟",
    title: "演唱会安可时忘词的瞬间，为何比完美演出更动人",
    excerpt: "一段微小的不完美，反而让偶像与粉丝的距离更近。名场面并不总是「满分时刻」，真实感同样拥有传播力。",
    time: "2026.08.28",
    img: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20glowing%20lights%20and%20crowd%20silhouettes%2C%20confetti%20in%20air%2C%20coral%20and%20gold%20cinematic%20tone%2C%20editorial%20concert%20photography%2C%20no%20face%20detail&width=800&height=600&seq=scene-s09&orientation=landscape",
  },
  {
    id: "s10", cat: "网红", tag: "考古现场", read: "3分钟",
    title: "被网友考古翻红的旧直播，凭什么二次爆火",
    excerpt: "当一段旧素材被重新解读，原本的语境被赋予新意义。考古网红名场面，本质上是一次大众共创的再叙事。",
    time: "2026.08.27",
    img: "https://readdy.ai/api/search-image?query=vintage%20video%20editing%20timeline%20and%20monitor%20with%20old%20footage%2C%20retro%20warm%20grain%2C%20mint%20and%20amber%20accents%2C%20editorial%20technology%20flatlay%20style&width=800&height=600&seq=scene-s10&orientation=landscape",
  },
  {
    id: "s11", cat: "综艺", tag: "竞演名场面", read: "4分钟",
    title: "竞演节目里「放弃镜头」的选手，却成了话题中心",
    excerpt: "当比赛规则与个人原则冲突，一次出人意料的取舍引爆讨论。综艺的戏剧张力，往往藏在台本之外的自主选择里。",
    time: "2026.08.26",
    img: "https://readdy.ai/api/search-image?query=dramatic%20competition%20show%20arena%20with%20single%20spotlight%20on%20empty%20center%20stage%2C%20deep%20warm%20shadow%20and%20coral%20light%2C%20cinematic%20editorial%20style&width=800&height=600&seq=scene-s11&orientation=landscape",
  },
  {
    id: "s12", cat: "剧组", tag: "杀青时刻", read: "4分钟",
    title: "杀青那晚的「最后一镜」，主创们都在躲镜头",
    excerpt: "杀青是杀青，也是告别。当最后一镜喊卡，有人笑着合影、有人独自走开，剧组趣闻里藏着最真实的职业情感。",
    time: "2026.08.25",
    img: "https://readdy.ai/api/search-image?query=film%20wrap%20party%20at%20night%20with%20string%20lights%20and%20cake%2C%20warm%20candlelight%2C%20friends%20hugging%20silhouettes%2C%20sentimental%20cinematic%20editorial%20photography%2C%20no%20clear%20faces&width=800&height=600&seq=scene-s12&orientation=landscape",
  },
];

export interface CircleNode {
  name: string;
  role: string;
  desc: string;
  count: string;
}

export const CIRCLES: CircleNode[] = [
  { name: "综艺观察团", role: "现象级现场诞生地", desc: "竞演、生存、观察类节目高频产出破圈名场面，嘉宾关系网与观众二创共同放大传播。", count: "收录 120+ 名场面" },
  { name: "剧组后援群", role: "台前幕后的暗线", desc: "从围读、对戏到杀青，主创与群演的真实生态，是理解一部作品温度的另一把钥匙。", count: "收录 96+ 条趣闻" },
  { name: "红毯与舞台", role: "聚光灯下的名场面", desc: "颁奖礼、音乐现场与时尚盛典里的即兴高光，是最考验临场功底与分寸感的场合。", count: "收录 84+ 高能时刻" },
  { name: "网红连麦圈", role: "实时共创的直播间", desc: "连麦、破圈、考古翻红，网红的圈层生态依赖即时互动，也是最「当下」的名场面。", count: "收录 76+ 现场记录" },
];

export interface RankItem {
  id: string;
  rank: string;
  title: string;
  type: string;
  heat: string;
  delta: string;
  img: string;
}

export const RANK: RankItem[] = [
  { id: "r1", rank: "01", title: "颁奖礼后台「黄金三分钟」救场发言", type: "明星名场面", heat: "928k", delta: "+12%", img: "https://readdy.ai/api/search-image?query=abstract%20warm%20spotlight%20glow%20on%20dark%20red%20stage%20curtain%20texture%2C%20coral%20and%20ink%20tones%2C%20editorial%20magazine%20style&width=240&height=240&seq=rank-r1&orientation=squarish" },
  { id: "r2", rank: "02", title: "竞演节目里「放弃镜头」的决定", type: "综艺高能", heat: "861k", delta: "+9%", img: "https://readdy.ai/api/search-image?query=single%20golden%20light%20beam%20in%20dark%20empty%20theater%20arena%2C%20amber%20and%20ink%2C%20minimal%20cinematic%20editorial&width=240&height=240&seq=rank-r2&orientation=squarish" },
  { id: "r3", rank: "03", title: "一场跑题连麦成就的神接梗弹幕", type: "网红现场", heat: "774k", delta: "+7%", img: "https://readdy.ai/api/search-image?query=mint%20green%20glowing%20digital%20chat%20bubble%20shapes%20floating%20on%20cream%20background%2C%20fresh%20editorial%20flat%20design&width=240&height=240&seq=rank-r3&orientation=squarish" },
  { id: "r4", rank: "04", title: "杀青夜那场没人愿意入镜的合影", type: "剧组趣闻", heat: "689k", delta: "+5%", img: "https://readdy.ai/api/search-image?query=warm%20string%20light%20bokeh%20at%20an%20evening%20gathering%2C%20candlelight%20amber%20tones%2C%20soft%20nostalgic%20editorial%20photo&width=240&height=240&seq=rank-r4&orientation=squarish" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const FAQS: FaqItem[] = [
  { q: "什么是「名场面」，为什么会被反复复盘？", a: "名场面通常指在明星现场、综艺竞演或剧组拍摄中，因临场发挥、真实反应或高能剧情而引发广泛讨论的瞬间。它们自带戏剧张力与情绪共鸣，容易被二次创作放大，因此具有跨圈层的传播力。" },
  { q: "「圈子图鉴」收录的内容都来自哪些场合？", a: "我们按明星、网红、综艺、剧组四大方向持续整理，覆盖红毯典礼、音乐现场、直播间连麦、真人秀录制与片场幕后。每条内容都以「现场」为核心，还原名场面发生的真实语境。" },
  { q: "为什么平台强调要「理性吃瓜」？", a: "娱乐内容以信息和情绪价值为主，我们倡导先了解事实语境、再参与讨论，不传播未经证实的片面信息。理性吃瓜，才能让名场面带给你的快乐更长久。" },
  { q: "平台的内容更新频率是怎样的？", a: "「国产吃瓜 · 圈子图鉴」采取持续收录机制，热门栏目与名场面盘点会随真实娱乐动态滚动更新，并保留足够的历史内容供按分类浏览。" },
  { q: "内容来源是否会标注？", a: "盘点类内容会以「现场记录 + 编辑部视角」的方式呈现，帮助你在有限的篇幅里快速建立对事件与人物关系的整体认知。" },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const TESTIMONIALS: Testimonial[] = [
  { name: "苏小糖", role: "综艺爱好者", text: "想补一档老综艺的课，从「名场面图鉴」一路刷下去，前因后果居然全串起来了，比零散热搜好懂太多。" },
  { name: "阿立", role: "短视频创作者", text: "找二创素材的灵感库！栏目把爆点归类得很清楚，参考它们的结构做视频，完播率高了不少。" },
  { name: "林一舟", role: "娱乐行业从业者", text: "圈子生态那几篇很见功力，把幕后的真实秩序讲明白了，不是那种只蹭热搜标题的搬运号。" },
];